module.exports = __webpack_public_path__ + "img/LUB00350.8bcc7e6a.png";